import React from 'react';
import axios from 'axios';

import styles from '../../styles/DynamicModal.module.css';

const AddNewFileToCase = ({ caseId, onNewFileSuccess }) => {
    const [isShowAddPanel, setIsShowAddPanel] = React.useState(false);
    const [fileNameFromUser, setFileNameFromUser] = React.useState('');
    const [file, setFile] = React.useState(null);
    const [status, setStatus] = React.useState('');
    const [error, setError] = React.useState('');

    const attachNewFile = (e) => {
        e.preventDefault();

        if (fileNameFromUser && file) {
            const formData = new FormData();
            formData.append('caseId', caseId);
            formData.append('fileNameFromUser', fileNameFromUser);
            formData.append('file', file); // Добавляем файл в запрос

            axios.post('/api/attach-new-file', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            }).then(() => {
                setStatus('Файл успешно прикреплен');
                onNewFileSuccess()
                setTimeout(() => {
                    setStatus('');
                    setFileNameFromUser('');
                    setFile(null);
                    setIsShowAddPanel(false);
                }, 2300);
            }).catch(error => {
                setError(`Ошибка при добавлении нового файла: ${error.response?.data.message || error.message}`);
            });
        } else {
            setError('Вы не ввели обязательные данные');
            setTimeout(() => {
                setError('');
            }, 3000);
        }
    }
    // Функция для обработки выбора файла
    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    return (
        isShowAddPanel ? (
        <>
            {!status &&
                <div className={styles.outliningPanel}>
                    <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: '10px'}}>
                        <h2 style={{margin: '0'}}>Добавьте новый файл</h2>
                        <img src='/img/icons/close-x.svg' alt='X' style={{width: '20px', cursor: 'pointer'}} onClick={() => {setIsShowAddPanel(false)}} />
                    </div>
                    <a>Введите название файла</a>
                    <input type='text' value={fileNameFromUser} onChange={(e) => setFileNameFromUser(e.target.value)} maxLength='100' placeholder='Название файла' required />
                    <a>Прикрепите файл (в формате .pdf)</a>
                    <div style={{boxShadow: '0 0 0 1px #e5e5e5', borderRadius: '8px', padding: '10px 20px', margin: '5px 0 5px 0'}}>
                        <input type='file' placeholder='Файл' accept=".pdf" onChange={handleFileChange} required />
                    </div>
                    <button type='submit' className='button maxWidth' style={{marginTop: '10px'}} onClick={(e) => {attachNewFile(e)}}>Добавить</button>
                    {error && <a className={styles.statusPanel}><img src='/img/icons/warning-icon.svg' alt='Предупреждение' />{error}</a>}
                </div>
            }
            {status && <a className={styles.statusPanel}><img src='/img/icons/check-circle.svg' alt='Статус' />{status}</a>}
        </>
        ) : (
            <button type='button' className='button maxWidth' style={{marginTop: '10px'}} onClick={() => {setIsShowAddPanel(true)}}>Добавить новый файл</button>
        )
    )
}

export default AddNewFileToCase;
